<template>
    <div>
        <div ref="item">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "MapPin",
    props: {
        map: {
            type: Object,
            required: true
        },
        coords: {
            type: Object,
            required: true
        }
    },
    watch: {
        coords: 'handleCoordChange'
    },
    data() {
        return {
            marker: null
        }
    },
    mounted() {
        this.recreate();
    },
    beforeDestroy() {
        this.remove();
    },
    methods: {
        handleCoordChange() {
            this.remove();
            this.recreate();
        },
        recreate() {
            const marker = this.map.addMarker(this.coords.lat, this.coords.lon);
            marker.node.append(this.$refs.item);
            this.marker = marker;
            this.$emit('markerSet', this.marker);
        },
        remove() {
            this.$refs.item.remove();
            this.marker.clearFromMap();
        },
    }
}
</script>